import { createAction, props } from '@ngrx/store';
import { OnboardingProposalAcceptProposalPost$Params } from '../../generated/auth/fn/onboarding/onboarding-proposal-accept-proposal-post';
import { OnboardingProposalDeclineProposalPost$Params } from '../../generated/auth/fn/onboarding/onboarding-proposal-decline-proposal-post';
import {
  SasfinWealthOnlineApiModelsResponsesApiNoContentResponse,
  SasfinWealthOnlineApiModelsResponsesApiResponseOfSasfinWealthOnlineBlModelsPagedResultOfSasfinWealthOnlineBlModelsProposalProposalManagementView,
  SasfinWealthOnlineApiModelsResponsesApiResponseOfSasfinWealthOnlineBlModelsProposalProposalDocReview,
  SasfinWealthOnlineApiModelsResponsesApiResponseOfSystemCollectionsGenericListOfSasfinWealthOnlineBlModelsProposalClientView,
} from '../../generated/auth/models';
import { ProposalFilters, ProposalLoadParams } from './proposal.model';

// Load proposals actions
export const loadProposalsForReview = createAction('[Proposal] Load Proposals for Review');

export const loadProposalsSuccess = createAction(
  '[Proposal] Load Proposals (Success)',
  props<{
    response: SasfinWealthOnlineApiModelsResponsesApiResponseOfSystemCollectionsGenericListOfSasfinWealthOnlineBlModelsProposalClientView;
  }>(),
);

export const loadProposalsFailure = createAction('[Proposal] Load Proposals (Failure)', props<{ error: string }>());

// Load proposals by creator
export const loadProposalsByCreator = createAction(
  '[Proposal] Load Proposals By Creator',
  props<{ params?: ProposalLoadParams }>(),
);

export const loadProposalsByCreatorSuccess = createAction(
  '[Proposal] Load Proposals By Creator (Success)',
  props<{
    response: SasfinWealthOnlineApiModelsResponsesApiResponseOfSasfinWealthOnlineBlModelsPagedResultOfSasfinWealthOnlineBlModelsProposalProposalManagementView;
    currentPage: number;
  }>(),
);

export const loadProposalsByCreatorFailure = createAction(
  '[Proposal] Load Proposals By Creator (Failure)',
  props<{ error: string }>(),
);

// Filter actions
export const setFilter = createAction('[Proposal] Set Filters', props<{ filter: Partial<ProposalFilters> }>());

export const resetFilter = createAction('[Proposal] Reset Filters');

export const updateFilter = createAction(
  '[Proposal] Update Filter',
  props<{ key: keyof ProposalFilters; value: any }>(),
);

// Pagination actions
export const updatePagination = createAction(
  '[Proposal] Update Pagination',
  props<{ page: number; pageSize: number }>(),
);

// Sorting actions
export const setSorting = createAction('[Proposal] Set Sorting', props<{ sortBy: string; sortDescending: boolean }>());

// Loading state actions
export const setLoading = createAction('[Proposal] Set Loading', props<{ isLoading: boolean }>());

// Load my proposals actions
export const loadMyProposals = createAction('[Proposal] Load My Proposals');

export const loadMyProposalsSuccess = createAction(
  '[Proposal] Load My Proposals (Success)',
  props<{
    response: SasfinWealthOnlineApiModelsResponsesApiResponseOfSystemCollectionsGenericListOfSasfinWealthOnlineBlModelsProposalClientView;
  }>(),
);

export const loadMyProposalsFailure = createAction(
  '[Proposal] Load My Proposals (Failure)',
  props<{ error: string }>(),
);

// Accept proposal actions
export const acceptProposal = createAction(
  '[Proposal] Accept Proposal',
  props<{ params: OnboardingProposalAcceptProposalPost$Params }>(),
);

export const acceptProposalSuccess = createAction(
  '[Proposal] Accept Proposal (Success)',
  props<{ response: SasfinWealthOnlineApiModelsResponsesApiNoContentResponse }>(),
);

export const acceptProposalFailure = createAction('[Proposal] Accept Proposal (Failure)', props<{ error: string }>());

// Decline proposal actions
export const declineProposal = createAction(
  '[Proposal] Decline Proposal',
  props<{ params: OnboardingProposalDeclineProposalPost$Params }>(),
);

export const declineProposalSuccess = createAction(
  '[Proposal] Decline Proposal (Success)',
  props<{ response: SasfinWealthOnlineApiModelsResponsesApiNoContentResponse }>(),
);

export const declineProposalFailure = createAction('[Proposal] Decline Proposal (Failure)', props<{ error: string }>());

// Error actions
export const clearError = createAction('[Proposal] Clear Error');

// Load proposal by ID actions
export const loadProposalById = createAction('[Proposal] Load Proposal By ID', props<{ id: number }>());

export const loadProposalByIdSuccess = createAction(
  '[Proposal] Load Proposal By ID (Success)',
  props<{ response: SasfinWealthOnlineApiModelsResponsesApiResponseOfSasfinWealthOnlineBlModelsProposalProposalDocReview }>(),
);

export const loadProposalByIdFailure = createAction(
  '[Proposal] Load Proposal By ID (Failure)',
  props<{ error: string }>(),
);

// Get proposal document actions
export const getProposalDocument = createAction('[Proposal] Get Proposal Document', props<{ documentId?: string }>());

export const getProposalDocumentSuccess = createAction(
  '[Proposal] Get Proposal Document (Success)',
  props<{ document: Blob }>(),
);

export const getProposalDocumentFailure = createAction(
  '[Proposal] Get Proposal Document (Failure)',
  props<{ error: string }>(),
);
